/**
 * navGuard — lets a page with unsaved changes ask before the portal moves
 * to another page (Availability, redesign screen 6: "Leave without saving?").
 *
 * The page registers a guard while it has unsaved changes. The guard gets
 * the move as a `proceed` callback; it returns true when it has taken over
 * (shown its own box, and will call proceed later or not at all), false to
 * let the move happen now.
 */
type Guard = (proceed: () => void) => boolean;

let guard: Guard | null = null;

export function setNavGuard(g: Guard | null): void {
  guard = g;
}

export function guardedNavigate(proceed: () => void): void {
  if (guard && guard(proceed)) return;
  proceed();
}
